import { useCallback, useMemo } from 'react';
import useExperiments from '@alltrails/experiments/hooks/useExperiments';
import useExposureEvent from '@alltrails/experiments/hooks/useExposureEvent';

const useNaturalLanguageSearchExperiment = () => {
  const experiments = useExperiments();
  const sendExposure = useExposureEvent('web-discover-rm-nls-improvements');

  const onInputFocus = useCallback(() => {
    sendExposure();
  }, [sendExposure]);
  const isNaturalLanguageSearchEnabled = experiments['web-discover-rm-nls-improvements']?.value === 'treatment';

  return useMemo(
    () => ({
      isNaturalLanguageSearchEnabled,
      onInputFocus
    }),
    [isNaturalLanguageSearchEnabled, onInputFocus]
  );
};

export default useNaturalLanguageSearchExperiment;
